import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import { FormElementModel } from "../../models/FormElementModel";
import { childRegisterForm } from "./inputsForm/InputChildFormModels";
import EAButton from "../shared/Buttons/EAButton";
import { Child } from "../../models/ParticipantRegistration";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import "./style.scss";

interface IProps {
  onSave: (child: Child) => void;
  onCancel?: () => void;
  initialData?: Child;
  isEditing?: boolean;
  newsletterAgreement: boolean;
}

const ChildForm: React.FC<IProps> = ({ onSave, onCancel, initialData, isEditing = false, newsletterAgreement }) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Child>({
    defaultValues: initialData
      ? {
          name: initialData.name,
          lastName: initialData.lastName,
          birthDate: format(initialData.birthDate, "yyyy-MM-dd") as any,
          newsletterAgreement: initialData.newsletterAgreement,
        }
      : {
          name: "",
          lastName: "",
          birthDate: "" as any,
          newsletterAgreement: newsletterAgreement,
        },
  });

  const handleSaveChild: SubmitHandler<Child> = (data) => {
    // Konwersja YYYY-MM-DD string na Date object
    const birthDate = new Date(data.birthDate as any);

    onSave({
      name: data.name,
      lastName: data.lastName,
      birthDate,
      newsletterAgreement,
    });
  };

  return (
    <form onSubmit={handleSubmit(handleSaveChild)} className="child-form">
      <div className="flex-start-center flex-wrap">
        {childRegisterForm(register).map((item: FormElementModel, index: number) => (
          <FormInput key={index} {...item} errors={errors} />
        ))}
      </div>

      <div className="child-form__buttons">
        <EAButton title={isEditing ? t("zapisz_zmiany") : t("dodaj_uczestnika")} inputType="submit" variant="filled" />
        {onCancel && <EAButton title={t("anuluj")} onClick={onCancel} variant="outlined" />}
      </div>
    </form>
  );
};

export default ChildForm;
